import React from "preact/compat";
import { TabsProps } from "./tabs.type";

export const Tabs: React.FunctionComponent<TabsProps> = ({
    tabs,
    site,
    counter,
    current,
    onClick
  }) => {
    const tabKeys = Object.keys(tabs);

    return (
        <ul className={`betslip-tabs ${site === 'covers' ? 'covers-tabs' : ''} nav nav-tabs mb-3 px-3`} role="tablist">
            {tabKeys.map((type, index) => {
                return (
                    <li key={index} className="nav-item pe-2" role="presentation">
                        <a className={`nav-link fs-8 fw-bold p-0 pb-1 lh-lg ${current === tabs[type] ? 'active' : ''}`} role="tab" onClick={onClick} aria-disabled={counter > 0 ? false : true}>{tabs[type]}</a>
                    </li>
                )
            })}
        </ul>
    )

};